module.exports = __webpack_public_path__ + "static/media/bath.9827b35c.jpg";